import {
    Component, Emit, Mixins,
} from 'vue-property-decorator';
import CoreMixin from '@nodes/mixins/Core';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import Props from './props';

@Component({
    components: {},
})
/**
 * @name Auth
 */
export default class Auth extends Mixins(CoreMixin, HybridMixin, Props) {
    /**
     * @inheritDoc
     */
    beforeCreate() {
        if (this.$route.query.logout) {
            this.$store.dispatch('auth/logout');
        }
        if (this.$store.getters['auth/isLoggedIn']) {
            this.$router.push({ name: 'home' });
        }
        if (localStorage.getItem('redirect')) {
            const params = JSON.parse(localStorage.getItem('redirect'));
            if (params.name) {
                this.$store.dispatch('auth/setRedirect', params);
            }
        }
    }

    /**
     * Back Button Function
     */
    @Emit('back')
    backButton() {}
}
